// Partner Organizations Data for DCELC

export const partnerOrganizations = {
  dcaeyc: {
    id: "dcaeyc",
    name: "DC Association for the Education of Young Children",
    acronym: "DCAEYC",
    website: "https://www.dcaeyc.org/",
    description: "The District of Columbia Association for the Education of Young Children (DCAEYC) empowers early childhood educators and child care professionals across Washington, DC. As the local affiliate of NAEYC, DCAEYC advances high-quality early learning through advocacy, professional development, and community building.",
    mission: "To support educators, strengthen the workforce, and champion equity and excellence for all young children and families in the District.",
    color: "blue",
    focus: [
      {
        title: "Professional Development",
        description: "Providing meaningful opportunities for early childhood professionals to grow and advance in their careers."
      },
      {
        title: "Advocacy",
        description: "Championing policies that support high-quality early childhood education across the District."
      },
      {
        title: "Community Building",
        description: "Connecting educators, families, and community members to strengthen the ECE ecosystem."
      },
      {
        title: "NAEYC Affiliation",
        description: "As the local NAEYC affiliate, connecting DC educators to national standards and resources."
      }
    ],
    membership: {
      title: "Become a DCAEYC Member",
      description: "Join DCAEYC to access professional development opportunities, networking events, advocacy updates, and be part of a community dedicated to early childhood excellence."
    },
    events: [
      "Annual Membership Meeting",
      "Board Elections",
      "Professional Development Workshops",
      "Networking Events"
    ]
  },
  msspa: {
    id: "msspa",
    name: "Multicultural Spanish Speaking Providers Association",
    acronym: "MSSPA",
    website: "https://www.msspadc.org/",
    description: "MSSPA is dedicated to uniting Latina early childhood educators in Washington, D.C., promoting high-quality early education and supporting the diverse needs of its members through advocacy, training, and access to essential resources.",
    mission: "To support Spanish-speaking early childhood educators through advocacy, training, and access to essential resources. By uplifting their voices and addressing systemic barriers, we help build a more inclusive and dignified future for providers and the children they serve.",
    color: "rose",
    focus: [
      {
        title: "Professional Development",
        description: "Tailored professional development opportunities and bilingual educational resources designed for Spanish-speaking providers."
      },
      {
        title: "Advocacy",
        description: "Advocating for fair policies, better working conditions, and recognition of Spanish-speaking providers."
      },
      {
        title: "Resources & Support",
        description: "Connecting educators to essential services including health insurance, Pay Equity Fund, and career advancement programs."
      },
      {
        title: "Community Networking",
        description: "Building a supportive community of Spanish-speaking early childhood educators across all eight DC wards."
      }
    ],
    impact: {
      title: "Community Impact",
      description: "MSSPA supports early childhood educators across Washington, DC through outreach, coaching, training, and access to essential resources—creating meaningful impact across all eight DC wards."
    },
    services: ["Training", "Advocacy", "Networking", "Resources"],
    partners: ["UDC", "DCAEYC", "The Women's Foundation", "DCELC", "Briya", "Community Foundation"]
  },
  dcheadstart: {
    id: "dcheadstart",
    name: "DC Head Start Association",
    acronym: "DCHSA",
    website: "https://www.dcheadstart.org/",
    description: "The DC Head Start Association provides unified leadership and support for all Early Head Start and Head Start programs within the District of Columbia, serving the most vulnerable pregnant women, infants, toddlers, preschool-aged children, and their families.",
    mission: "To provide unified leadership and support for all Early Head Start and Head Start programs within the District of Columbia.",
    color: "emerald",
    focus: [
      {
        title: "Leadership",
        description: "Fostering leadership growth among Early Head Start and Head Start staff, as well as parents of young children."
      },
      {
        title: "Professional Development",
        description: "Collaborating with partners to provide professional development opportunities tailored to staff roles and family needs."
      },
      {
        title: "Public Policy & Advocacy",
        description: "Advocating for high-quality, continuous, and comprehensive early childhood development services and supports."
      },
      {
        title: "Parent & Family Engagement",
        description: "Strengthening the role of parents and families as their child's first and most important teacher."
      }
    ],
    impact: {
      stats: [
        { value: "7,000", label: "Children Served by 2025" },
        { value: "2,500", label: "Staff Delivering Services" },
        { value: "1,900", label: "Volunteers" }
      ],
      description: "Making a profound difference in Washington, DC by serving the most vulnerable through Early Head Start and Head Start programs."
    }
  },
  dcfcca: {
    id: "dcfcca",
    name: "DC Family Child Care Association",
    acronym: "DCFCCA",
    website: "http://www.dcfcca.us/about-us.html",
    description: "The DC Family Child Care Association supports those who support the District's young children and families in home-based child care settings, providing advocacy and building strong professional connections.",
    mission: "To educate and provide advocacy efforts for family child care educators through building strong professional connections by enhancing the lives of family child care professionals and families they serve.",
    vision: "Ensuring Family Childcare Educator's influential voices that attract members and supporters, and ultimately improves the quality and state of early childhood education and development.",
    color: "amber",
    focus: [
      {
        title: "Advocacy",
        description: "Advocating for equitable pay and resources for home-based child care providers."
      },
      {
        title: "Professional Connections",
        description: "Building strong professional networks among family child care educators."
      },
      {
        title: "Voice & Recognition",
        description: "Ensuring family child care voices are heard and recognized for their dedication to early childhood education."
      },
      {
        title: "Resources & Support",
        description: "Providing resources and guidance for becoming and succeeding as a family child care teacher."
      }
    ],
    leadership: {
      executiveDirector: "Cynthia Davis",
      programCoordinator: "Sherese Manns"
    }
  },
  waccc: {
    id: "waccc",
    name: "Washington Association of Child Care Centers",
    acronym: "WACCC",
    website: null,
    description: "The Washington Association of Child Care Centers (WACCC) represents center-based child care programs across Washington, DC. WACCC provides a unified voice for child care center owners and directors, advocating for improved family services, equitable workforce support, and sustainable early learning programs.",
    mission: "To advocate for center-based child care programs and provide support for owners, directors, and staff working to deliver high-quality early childhood education in the District.",
    color: "violet",
    focus: [
      {
        title: "Center Advocacy",
        description: "Representing the interests of center-based child care programs in policy discussions and regulatory matters."
      },
      {
        title: "Quality Improvement",
        description: "Supporting centers in meeting and exceeding quality standards for early childhood education."
      },
      {
        title: "Workforce Development",
        description: "Addressing staffing challenges and supporting professional development for center staff."
      },
      {
        title: "Business Support",
        description: "Providing resources and guidance for sustainable child care center operations."
      }
    ],
    services: [
      "Policy advocacy for center-based programs",
      "Networking opportunities for center directors",
      "Professional development resources",
      "Regulatory guidance and compliance support"
    ]
  },
  directorsExchange: {
    id: "directors-exchange",
    name: "Directors Exchange",
    acronym: "DE",
    website: null,
    description: "Directors Exchange is a professional organization representing directors of child care facilities (Child Development Facilities or CDFs) in Washington, DC. It serves as a vital network for directors navigating the challenges of running early childhood programs in the District.",
    mission: "To support and connect child care facility directors across Washington, DC, providing peer networks, professional resources, and a collective voice in policy discussions affecting early childhood programs.",
    color: "cyan",
    focus: [
      {
        title: "Peer Networking",
        description: "Creating opportunities for directors to connect, share experiences, and learn from one another."
      },
      {
        title: "Policy Engagement",
        description: "Representing directors' perspectives in policy discussions including subsidy programs and Pay Equity Fund implementation."
      },
      {
        title: "Professional Support",
        description: "Providing resources and support for directors managing staff, budgets, and program quality."
      },
      {
        title: "Workforce Advocacy",
        description: "Advocating for equitable pay, health benefits, and professional development for the early childhood workforce."
      }
    ],
    involvement: [
      "Participation in DC Commission on Early Childhood Teacher Compensation",
      "Collaboration with OSSE on subsidy program improvements",
      "Partnership with DC Early Learning Collaborative (DCELC)",
      "Advocacy for HealthCare4ChildCare and Pay Equity Fund programs"
    ]
  }
};
